import React from "react"
import ReactDOM from "react-dom"
import {GoogleOAuthProvider} from "@react-oauth/google"

import App from "./App"

ReactDOM.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_OAUTH2_CLIENT_ID || ""}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>,
  document.getElementById("root"),
)
